import Axios from '../config/axios';
import { atom } from 'recoil';
import Globals from '../config/globals';

export const canSelectedJobBeUpdated = atom({
    key: 'canSelectedJobBeUpdated',
    default: false
});

export const canSelectedJobBeDeleted = atom({
    key: 'canSelectedJobBeDeleted',
    default: false
});

export const activeExpandJobWorkflow = atom({
    key: 'activeExpandJobWorkflow',
    default: false
});

export const activeUserJobsState = atom({
    key: 'activeUserJobsState',
    default: {}
});

export const activeJobTab = atom({
    key: 'activeJobTab',
    default: 'myJobs'
});

export const jobTableParams = atom({
    key: 'jobTableParams',
    default: {
        pagination: {
            current: 1,
            pageSize: 10,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            showSizeChanger: true,
            showQuickJumper: true,
            size: 'default'
        },
    }
});

export function getJobsByOrganization(org_ID, users_ID) {
    return Axios.get('/api/GetJobsByOrganization', {
        params: {
            org_ID,
            users_ID
        }
    }).then(response => response.data).catch(error => error);
}

export function getJobDashboardInformation(jobs_ID, users_ID) {
    return Axios.get('/api/GetJobDashboardInformation', {
        params: {
            jobs_ID,
            users_ID
        }
    }).then(response => response.data).catch(error => error);
}

export function addJob(postdata) {
    return Axios.post(`/api/AddJob`, postdata
    ).then(response => response.data).catch(error => error);
}

export function updateJob(postdata) {
    return Axios.post(`/api/UpdateJob`, postdata
    ).then(response => response.data).catch(error => error);
}

export function deleteJob(postdata) {
    return Axios.post(`/api/DeleteJob`, postdata).then(response => response.data).catch(error => error);
}

export function archiveJob(postdata) {
    return Axios.post(`/api/ArchiveJob`, postdata).then(response => response.data).catch(error => error);
}

export function restoreJob(postdata) {
    return Axios.post(`/api/RestoreJob`, postdata).then(response => response.data).catch(error => error);
}

export function bulkArchiveJobs(idList) {
    return Axios.post(`/api/BulkArchiveJobs`, idList
    ).then(response => response.data).catch(error => error);
}

export function bulkRestoreJobs(idList) {
    return Axios.post(`/api/BulkRestoreJobs`, idList
    ).then(response => response.data).catch(error => error);
}

export function getMatchedJobs(candidates_ID, users_ID) {
    return Axios.get('/api/GetMatchedJobs', {
        params: {
            candidates_ID,
            users_ID
        }
    }).then(response => response.data).catch(error => error);
}

export function getJobsWithPlacementsByUser(org_ID, users_ID, placementStatus) {
    return Axios.get('/api/GetJobsWithPlacementsByUser', {
        params: {
            org_ID,
            users_ID,
            placementStatus
        }
    }).then(response => response.data).catch(error => error);
}

export function removeJobsFromNchcr(idList, placementStatus) {
    let postdata = {
        org_ID: Globals.userInfo.organizations_ID,
        users_ID: Globals.userInfo.users_ID,
        userType: Globals.userInfo.userType,
        idList,
        placementStatus
    }

    return Axios.post(`/api/RemoveJobsFromNCHCR`, postdata).then(response => response.data).catch(error => error);
}